import cloneDeep from 'lodash.clonedeep';

interface Sortable {
  id: string;
}

export default function multiDragAwareReorder<T extends Sortable>(
  list: T[],
  source: { index: number },
  destination: { index: number },
  draggableId: string,
  selectedIds: string[]
) {
  if (selectedIds.length > 1) {
    const sortedSelectedIds = list.filter(listItem => selectedIds.includes(listItem.id)).map(listItem => listItem.id);
    const movingItems: T[] = [];
    sortedSelectedIds.forEach(id => {
      const itemToClone = list.find(listItem => listItem.id === id);
      if (!itemToClone) return;

      movingItems.push(cloneDeep(itemToClone));
    });

    const newItems = Array.from(list);
    newItems.splice(source.index >= destination.index ? destination.index : destination.index + 1, 0, ...movingItems);

    const reorderedItems = newItems
      .filter(listItem => {
        const itemNotSelected = !selectedIds.includes(listItem.id);
        const itemSelected = !itemNotSelected;
        const itemMoved = movingItems.includes(listItem);
        return itemNotSelected || (itemSelected && itemMoved);
      });

    return reorderedItems;
  } else {
    const reorderedItems = Array.from(list);
    const itemToSort = list.find(listItem => listItem.id === draggableId);

    if (!itemToSort) {
      return list;
    }

    reorderedItems.splice(source.index, 1);
    reorderedItems.splice(destination.index, 0, itemToSort);
    return reorderedItems;
  }
}
